<template>
    <div>
        <myPage>
            <div class="flex-box nopadding wrap pd-left5 pd-bottom5" slot="header">
                <el-button-group class="mg-right5 mg-top5 flex-box nopadding">
                    <el-button size="small" :title="$t('refs')" icon="el-icon-refresh" @click="getInfo()"></el-button>
                </el-button-group>
            </div>
            <div class="fillw fillh">
                <my-sub-title class="pd-top10">Api 秘钥</my-sub-title>
                <el-input class="mg-top5 width-500" v-model="api_key" placeholder="请输入">
                    <span slot="prepend" class="f-blue">完整接口秘钥： </span>
                </el-input>
                <my-sub-title class="pd-top20">客户信息</my-sub-title>
                <div class="bg-f8 mg-top5">
                    <div class="flex-box border-bottom-line">
                        <div class="width-150 tright">客户ID(org_id)：</div>
                        <div class="flex-box-bd tleft f-bd">{{info.org_id}}</div>
                    </div>
                    <div class="flex-box border-bottom-line">
                        <div class="width-150 tright">接口秘钥(api_key)：</div>
                        <div class="flex-box-bd tleft f-bd">{{info.api_key || '未生成'}}</div>
                    </div>
                    <div class="flex-box border-bottom-line">
                        <div class="width-150 tright">信誉额度：</div>
                        <el-tag size="mini">{{info.cr_cat_cdesc}}</el-tag>
                        <div class="tleft f-bd mg-left5">{{info.cr_qty || '***'}}</div>
                        <div class="flex-box-bd"></div>
                        <div class="width-60">
                            <a class="link" @click="getOrgInfo()">接口获取</a>
                        </div>
                    </div>
                    <div class="flex-box">
                        <div class="flex-box-bd"></div>
                        <div>
                            <el-checkbox v-model="show_up_flag" true-label="1" false-label="0" @change="getInfo()">仅显示已上架商品</el-checkbox>
                        </div>
                    </div>
                </div>
                <div class="mg-top20" v-for="(item,index) in cats" :key="item.cat_id">
                    <my-sub-title>{{item.cat_cname}}</my-sub-title>
                    <div class="bg-f8 mg-top10" v-for="(item2,index2) in item.children" :key="item.cat_id2">
                        <div class="pd-5 f-bd tcenter bg-back">{{item.cat_cname}} - {{item2.cat_cname}}</div>
                        <div class="flex-box border-bottom-line f-bd">
                            <div class="width-250 tleft">商品ID(goods_id)</div>
                            <div class="flex-box-bd tleft">名称</div>
                            <div class="width-100 tleft">面值</div>
                            <div class="width-100 tleft">结算价</div>
                            <div class="width-60"></div>
                        </div>
                        <div class="flex-box border-bottom-line" v-for="(item3,index3) in item2.goods" :key="item3.org_goods_id">
                            <div class="width-60">
                                <myImgshow :src="item3.img_lnk" @onClick="$base.alertImg(item3.img_lnk, item3.goods_cname)"></myImgshow>
                            </div>
                            <div style="width: 10px"></div>
                            <div class="width-180 tleft f-bd">{{item3.goods_id}}</div>
                            <div class="flex-box-bd tleft">
                                <el-tag size="mini" :class="item3.org_goods_id != '' && item3.org_goods_status == '1'?'bg-green':'bg-gray'">
                                    {{item3.org_goods_status_cdesc || '未配置'}}
                                </el-tag>
                                <div class="mg-top5 f-bd">{{item3.goods_cname}}</div>
                            </div>
                            <div class="width-100 tleft f-red">{{item3.new_price * 1}}元</div>
                            <div class="width-100 tleft f-blue">
                                <span v-if="item3.cost_amt != ''">{{item3.cost_amt * 1}}元</span>
                                <span v-else>按约定</span>
                            </div>
                            <div class="width-60">
                                <el-popover placement="bottom">
                                    <div class="flex-box nopadding hand" slot="reference">
                                        <a class="link">接口下单</a>
                                    </div>
                                    <div class="flex-box nopadding">
                                        <el-input size="small" class="width-200 mg-right5" v-model="item3.guest_order_code">
                                            <span slot="prepend">订单号</span>
                                        </el-input>
                                        <el-input size="small" class="width-200 mg-right5" v-model="item3.mobile">
                                            <span slot="prepend">手机号码</span>
                                        </el-input>
                                        <el-button size="small" type="primary" @click="add(item3)">执行</el-button>
                                    </div>
                                </el-popover>
                            </div>
                        </div>
                    </div>
                </div>
                <my-sub-title class="mg-top20">核实订单</my-sub-title>
                <div class="flex-box nopadding mg-top5">
                    <el-input class="width-300" v-model="guest_order_code" placeholder="请输入">
                        <span slot="prepend">订单号： </span>
                    </el-input>
                    <el-button class="mg-left5" @click="check">核实订单</el-button>
                </div>
                <div class="height-30"></div>
            </div>
        </myPage>
    </div>
</template>

<script>
    import request from '../../../utils/request_api';
    import myImgshow from '../../../components/myImgshow'
    import {chkOrderCharge} from "../../../utils/base";
    export default {
        name:"dp-api",
        components:{
            myImgshow
        },
        data:function(){
            return{
                show_up_flag: '1',
                info: {},
                vendors:[],
                cats:[],
                api_key:'',
                guest_order_code: ''
            }
        },
        activated:function(){
            this.$base.setMenuOpens();
        },
        mounted: function(){
            this.$base.setMenuOpens();
            this.getInfo();
        },
        methods:{
            getInfo: function(){
                var data = {
                    show_up_flag: this.show_up_flag
                }
                this.$base.showLoading();
                this.$request.sendPost("org-dp-api/get-info", data,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.info = data.info;
                        this.vendors = data.vendors;
                        this.cats = data.cats;
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            getOrgInfo: function() {
                if(this.api_key == ''){
                    this.$base.alertErr('请输入完成接口秘钥');
                    return;
                }
                var data = {
                    org_id: this.info.org_id,
                    send_time: this.$moment().unix()
                };
                data.sign = this.$base.toMD5(data.org_id + data.send_time + this.api_key).toUpperCase();
                this.$base.showLoading();
                request.sendPost_open("com/get-org-info",data,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.info.cr_qty = data.cr_qty;
                        this.$forceUpdate();
                        this.$base.alertSuccess();
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            // getVendorBalAmt: function(item) {
            //     if(this.api_key == ''){
            //         this.$base.alertErr('请输入完成接口秘钥');
            //         return;
            //     }
            //     var data = {
            //         org_id: this.info.org_id,
            //         vendor_id: item.vendor_id,
            //         send_time: this.$moment().unix()
            //     };
            //     data.sign = this.$base.toMD5(data.org_id + data.vendor_id + data.send_time + this.api_key).toUpperCase();
            //     this.$base.showLoading();
            //     request.sendPost_open("com/get-vendor-bal-amt",data,(success,data,error)=>{
            //         this.$base.hideLoading();
            //         if(success){
            //             item.bal_amt = data.bal_amt;
            //             this.$base.alertSuccess();
            //         }
            //         else{
            //             this.$base.alertErr(error.errmsg);
            //         }
            //     });
            // },
            add: function(item){
                if(item.mobile == "" || item.guest_order_code == ""){
                    this.base.msgErr('请输入订单号和手机号码');
                    return;
                }
                var data = {
                    org_id: this.info.org_id,
                    guest_order_code: item.guest_order_code,
                    mobile: item.mobile,
                    goods_id: item.goods_id,
                    goods_amt: item.new_price,
                    send_time: this.$moment().unix()
                }
                data.sign = this.$base.toMD5(data.org_id + data.guest_order_code + data.mobile + data.goods_id + data.send_time + this.api_key).toUpperCase();
                this.$base.showLoading();
                request.sendPost_open("order/add", data,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        // this.$base.showLoading('下单成功，正在获取充值结果');
                        // this.$base.chkOrderCharge(data.order_code,(data)=>{
                        //     this.$base.hideLoading();
                        //     this.$base.alertSuccess('充值结果：' + data.order_status_cdesc);
                        // });
                        this.$base.msgSuccess('下单成功，可前往订单管理查询订单状态');
                        this.$base.bodyClick();
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            check: function(){
                if(this.guest_order_code == ""){
                    this.base.msgErr('请输入订单号');
                    return;
                }
                var data = {
                    org_id: this.info.org_id,
                    guest_order_code: this.guest_order_code,
                    send_time: this.$moment().unix()
                }
                data.sign = this.$base.toMD5(data.org_id + data.guest_order_code + data.send_time + this.api_key).toUpperCase();
                this.$base.showLoading();
                request.sendPost_open("order/check", data,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.$base.alertSuccess("核实结果：" + data.order_status_cdesc);
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            }
        }
    }
</script>

<style scoped >
</style>



// WEBPACK FOOTER //
// src/pages/dp/api/list.vue